import { memo, type ComponentProps } from 'react'
import { useRive } from '@rive-app/react-canvas'
import { useRiveLoaderFile } from '@/contexts/RiveLoaderContext'

const LoadingAnimation = (props: ComponentProps<'canvas'>) => {
  const riveFile = useRiveLoaderFile()
  // Params stay null until the shared file has preloaded — creating a Rive
  // instance from a loaded RiveFile involves no file fetch to race against
  // unmount.
  const { RiveComponent } = useRive(
    riveFile ? { riveFile, stateMachines: 'greenLoaderSM', autoplay: true } : null
  )

  return (
    <RiveComponent
      style={{
        maxWidth: '480px',
        maxHeight: '480px',
        width: '200px',
        height: '200px',
        margin: '20px'
      }}
      {...props}
    />
  )
}

export default memo(LoadingAnimation)
